import { render, staticRenderFns } from "./AdminDepartments.vue?vue&type=template&id=650e3d77&"
import script from "./AdminDepartments.vue?vue&type=script&lang=js&"
export * from "./AdminDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports